import { memo } from "react";
import IconWrapper, { IconWrapperProps } from "@repo/ui/src/components/IconWrapper";

interface YoutubeIconProps extends IconWrapperProps {
  backFillColor: string;
  frontFillColor: string;
}

const YoutubeIcon = ({
  backFillColor,
  frontFillColor,
  ...rest
}: YoutubeIconProps) => (
  <span>
    <IconWrapper
      width="40px"
      viewBox="0 0 40 40"
      title="Youtube Link"
      {...rest}
    >
      <g
        id="youtube"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Share-Button-Youtube">
          <rect
            fill={backFillColor}
            x="0"
            y="0"
            width="40"
            height="40"
            rx="20"
          />
          <g
            id="youtube-brands"
            transform="translate(10.000000, 13.000000)"
            fill={frontFillColor}
            fillRule="nonzero"
          >
            <path d="M19.5494526,2.19281022 C19.320219,1.32967153 18.6448175,0.649890511 17.7872628,0.41919708 C16.2328832,0 10,0 10,0 C10,0 3.76715328,0 2.21273723,0.41919708 C1.35518248,0.649927007 0.679781022,1.32967153 0.450547445,2.19281022 C0.0340510949,3.75729927 0.0340510949,7.02145985 0.0340510949,7.02145985 C0.0340510949,7.02145985 0.0340510949,10.2856204 0.450547445,11.8501095 C0.679781022,12.7132482 1.35518248,13.364708 2.21273723,13.5954015 C3.76715328,14.0145985 10,14.0145985 10,14.0145985 C10,14.0145985 16.2328467,14.0145985 17.7872628,13.5954015 C18.6448175,13.364708 19.320219,12.7132482 19.5494526,11.8501095 C19.9659489,10.2856204 19.9659489,7.02145985 19.9659489,7.02145985 C19.9659489,7.02145985 19.9659489,3.75729927 19.5494526,2.19281022 Z M7.96149635,9.98507299 L7.96149635,4.05784672 L13.1709489,7.02153285 L7.96149635,9.98507299 Z" />
          </g>
        </g>
      </g>
    </IconWrapper>
  </span>
);

export default memo(YoutubeIcon);
